import Mixpanel from '@segment/analytics.js-integration-mixpanel';

/**
 * Here, all integrations
 */
export default {
  Mixpanel,
};



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/integrations/index.js